import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseAPIService } from '../base.api.service';

@Injectable()
export class TempService extends BaseAPIService {

    private ROUTES = {
        uploadEvent: '/package',
        validEvent: '/package/valid',
        getEvent: '/package',
        getPremiums: '/package/premiums',
        uploadGiftTrigger: '/gift-trigger'
    };

    constructor(protected http: HttpClient) {
        super(http);
    }

    uploadEvent(
        eventTime: string,
        packageType: string,
        startTime: number,
        endTime: number,
        packages: any[],
        premiums: any[]
    ): Promise<any> {
        return this.POST(this.ROUTES.uploadEvent, null,
            { eventTime, packageType, startTime, endTime, packages, premiums }
        ).toPromise();
    }

    getEvent(eventTime: number, type: string): Promise<any> {
        return this.GET(this.ROUTES.getEvent, null, { params: { eventTime, type } }).toPromise();
    }

    getPremiums(eventInfoId: number): Promise<any> {
        return this.GET(this.ROUTES.getPremiums, null, { params: { eventInfoId } }).toPromise();
    }

    validEvent(
        packageType: string,
        startTime: string,
        endTime: string
    ): Promise<any> {
        return this.GET(this.ROUTES.validEvent, null, { params: { packageType, startTime, endTime } }).toPromise();
    }

    uploadGiftTrigger(startTime: string, endTime: string, list: any[]): Promise<any> {
        return this.POST(this.ROUTES.uploadGiftTrigger, null, { startTime, endTime, list }).toPromise();
    }

    getGiftTrigger(startTime: string, endTime: string): Promise<any> {
        return this.GET(this.ROUTES.uploadGiftTrigger, null, { params: { startTime, endTime } }).toPromise();
    }

    deleteGiftTrigger(id: number): Promise<any> {
        return this.DELETE(`${this.ROUTES.uploadGiftTrigger}/${id}`, null).toPromise();
    }
}
